import Component from '../core/Component'
import EventBus from '../core/EventBus'

export const STATES = {
    LOADING: 'is-loading',
    DONE: 'is-done'
}

export default class Form extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            submit: null,
        }
    }

    prepare() {
        if (this.element.closest('.FullModal')) {
            this.modal = Component.getFromElement(this.element.closest('.FullModal').id)
        }

        if (this.ref.submit) {
            this.element.addEventListener('click', this.handleClick)
            EventBus.on('nette:event', this.handleNetteEvent);
        }
    }

    destroy() {
        if (this.ref.submit) {
            this.element.removeEventListener('click', this.handleClick)
            EventBus.off('nette:event', this.handleNetteEvent);
        }
    }

    handleClick = event => {
        if (event.target.closest('label') || event.target.closest('input:not([type=text])')) {
            this.addLoading()
        }

        if (event.target.closest('button') == this.ref.submit || event.target.closest('.SearchBox-submit')) {
            this.addLoading()
            this.submited = true
        }
    }

    handleNetteEvent = event => {
        if (this.element.id.indexOf(event.name) != -1 && event.status == "success") {
            this.removeLoading()

            if (this.modal && this.submited) {
                this.modal.close()
                this.submited = false
            }
        }
    }

    addLoading() {
        this.ref.submit.classList.add(STATES.LOADING)
        this.ref.submit.classList.remove(STATES.DONE)
    }

    removeLoading() {
        this.ref.submit.classList.remove(STATES.LOADING)
        this.ref.submit.classList.add(STATES.DONE)
    }
}
